<template>
     <div class="accordion-item">
        <h3 class="accordion-header" id="class-header">
            <button class="accordion-button d-flex" type="button" data-bs-toggle="collapse" data-bs-target="#class-collapse" aria-expanded="true" aria-controls="class-collapse">
                <div class="flex-grow-1">
                    <div class="h6">My Classes</div>
                    <div v-if="selected?.id" class="small text-primary">{{ selected.name }}</div>
                    <div v-else class="small text-danger">No Class Selected</div>
                </div>
            </button>
        </h3>
        <div id="class-collapse" class="accordion-collapse collapse" :class="classes.length ? '' : 'show'" classes aria-labelledby="class-header" data-bs-parent="#accordion-filter-options" ref="accbody">
            <div class="accordion-body">
                <div class="list-group list-group-selectable">
                    <div v-for="cl in classes" class="list-group-item d-flex" @click="selected = cl" :active="selected==cl">
                        <span class="flex-grow-1">{{ cl.name }}</span>
                        <span class="text-primary me-2" @click="enroll(cl.id)" title="Enroll students"><i class="fas fa-users-cog"></i></span>
                        <span class="text-primary" @click="edit(cl.id)" title="Edit class"><i class="fas fa-edit"></i></span>
                    </div>
                    <div class="text-end mt-3">
                        <button class="btn btn-primary btn-sm" @click="create"><i class="fa-solid fa-users-rectangle me-2"></i>Create Class</button>
                    </div>

                    <!-- <div v-if="!classes.length">
                        <button class="btn btn-primary btn-sm" @click="create"><i class="fa-solid fa-users-rectangle"></i> Create class</button>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueCookies from 'vue-cookies';

export default {
    components: { VueCookies },

    mounted() {
        this.$parent.isLoading = true;
        axios
            .get('/api/classes')
            .then(response => {
                this.classes = response.data.classes;
                
                // Delete cookie if classes have been deleted
                if (this.classes.length == 0) {
                    if (VueCookies.isKey('cl')) {
                        try {
                            VueCookies.remove('cl');
                        } catch (e) {
                            console.warn('Class: Could not delete cookie');
                        }
                    }
                }
            })
            .catch(error => {
                console.error(error);
            })
            .finally(() => {
                this.$parent.isLoading = false;
                console.log(this.selected);
            })

        if (VueCookies.isKey('cl')) {
            try {
                this.selected = VueCookies.get('cl');
            } catch (e) {
                console.warn('Class: Bad cookie data');
                VueCookies.remove('cl');
            }
        }

        this.$refs.accbody.addEventListener('hide.bs.collapse', event => {
            VueCookies.set('cl', this.selected, Infinity);
        });
    },

    methods: {
        edit: function(clid) {
            this.$router.push(`/classes/ed${clid}`);
        },
        enroll: function(clid) {
            this.$router.push(`/classes/en${clid}`);
        },
        create: function() {
            this.$router.push('/classes');
        }
    },

    watch: {
        selected: function() {
            this.$emit('update', this.selected);
        }
    },

    data() {
        return {
            classes: [],
            selected: {}
        }
    }
}
</script>